// THE TWO NUMBERS ON A CHARGE WAITING TO BE RAISED: what the cost was, and what we said
// we would charge for it.
//
// One component because both rows that draw an expected charge need it — a job card's
// own rows, and the pending-conversion row for a cost on a job that does not bill yet —
// and two copies would be two chances for one of them to start filling the blank in.
//
// A MISSING CHARGE IS PRINTED AS MISSING. The amount is optional on purpose: the price
// is often not agreed when the cost is recorded, and demanding one there would only
// produce an invented figure. So it reads "טרם נקבע" and never falls back to the cost,
// which would show a zero-margin charge nobody agreed to, on the one screen whose whole
// discipline is not to invent figures.
//
// NEITHER NUMBER IS A RECEIVABLE. The cost is spent money and the charge is a plan;
// nobody owes anything until an invoice is recorded. They enter no total on this screen.
import he from '../../i18n/he';
import Money, { Cost } from '../../components/Money';
import DateText from '../../components/DateText';

const t = he.collections.board;

export default function ChargeAmounts({ row }) {
  return (
    <span className="muted">
      {t.cost}: <Cost value={row.cost} />
      {' · '}
      {he.expenses.chargeShort}:{' '}
      {row.chargeAmount != null
        ? <strong><Money value={row.chargeAmount} /></strong>
        : he.expenses.chargeNotSet}
      {row.expenseDate && <>{' · '}<DateText value={row.expenseDate} /></>}
    </span>
  );
}
